import React, { useState } from "react";
import { MoreOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import { AiOutlineEdit } from "react-icons/ai";
import { BsTrash } from "react-icons/bs";
import { DeleteModal } from "./DeleteModal";
import { ArchiveBoxIcon } from "../../../../assets/icons/ArchiveBoxIcon";
import ArchiveConfirmModal from "../../../../components/Archive/ArchiveConfirmModal";
import "../style.scss";

// `onArchive`, when given, adds "Archive" (components/Archive): it archives
// the workspace once confirmed.
function DropDownComp({ handleDelete, id, onEdit, onArchive }) {
   const [open, setOpen] = useState(false);
   const [isArchiveOpen, setIsArchiveOpen] = useState(false);
   const showModal = () => {
      setOpen(true);
   };

   const items = [
      {
         key: "edit",
         label: (
            <button type="button" onClick={onEdit}>
               <AiOutlineEdit /> Edit
            </button>
         )
      },
      ...(onArchive
         ? [
              {
                 key: "archive",
                 label: (
                    <button type="button" onClick={() => setIsArchiveOpen(true)}>
                       <ArchiveBoxIcon /> Archive
                    </button>
                 )
              }
           ]
         : []),
      {
         key: "delete",
         danger: true,
         label: (
            <button type="button" onClick={showModal}>
               <BsTrash /> Delete
            </button>
         )
      }
   ];
   return (
      <>
         <Dropdown
            trigger={["click"]}
            menu={{
               items
            }}
            overlayClassName="workspace-dropdown"
         >
            <button type="button" aria-label="Workspace actions">
               <MoreOutlined />
            </button>
         </Dropdown>

         <DeleteModal
            open={open}
            setOpen={setOpen}
            showModal={showModal}
            handleDelete={handleDelete}
            id={id}
         />

         {onArchive && (
            <ArchiveConfirmModal
               open={isArchiveOpen}
               label="workspace"
               onCancel={() => setIsArchiveOpen(false)}
               onConfirm={async () => {
                  await onArchive(id);
                  setIsArchiveOpen(false);
               }}
            />
         )}
      </>
   );
}

export { DropDownComp };
